// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfrastructurePage_root__QzMEp {
  min-height: 100vh;
  background: #00377C;
}`, "",{"version":3,"sources":["webpack://./src/pages/InfrastructurePage/InfrastructurePage.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;AACJ","sourcesContent":[".root {\n    min-height: 100vh;\n    background: #00377C;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InfrastructurePage_root__QzMEp`
};
export default ___CSS_LOADER_EXPORT___;
